import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store/index'

import util from '@/libs/util.js'
import { getmenus, getRoundStatus } from '@/api/menu'
import { Gtoken } from '@/config/index.js'
// 路由数据
import routes from './routes'

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  linkActiveClass: 'active',
  routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  // 进度条
  NProgress.start()
  store.commit('d2admin/sager/changurl', to)
  const token = util.cookies.get('token')
  console.log('路由拦截token', token)
  Gtoken.aaa = util.cookies.get('token')
  if (token) {
    const res = await getmenus()
    store.commit('d2admin/menu/authurl', res.permissionsHasUrl)
    store.commit('d2admin/menu/authSet', res.permissions)
    store.commit('d2admin/menu/autcooperate', res.cooperate)
    const matchId = store.getters['d2admin/user/getMatchStatus'].matchId
    if (matchId) {
      const roundStatus = await getRoundStatus()
      store.commit('d2admin/menu/roundStatus', roundStatus.data.status)
    }
  }
  if (token && to.path == '/login') {
    next({
      name: 'index',
    })
    NProgress.done()
    return
  }
  store.commit('d2admin/search/set', false)
  // 验证当前路由所有的匹配中是否需要有登录验证的
  if (to.matched.some(r => r.meta.auth)) {
    // 这里暂时将cookie里是否存有token作为验证是否登录的条件
    // 请根据自身业务需要修改
    // const token = util.cookies.get('token')


    if (token) {
      store.commit('d2admin/menu/cunttername', to.name)
      // // if (!store.state.d2admin.menu.url.includes(to.name)) {
      // //   next({
      // //     path: '/404'
      // //   })
      // // }
      //获取没有权限的路径
      const notAvailablePermissions = JSON.parse(localStorage.getItem('d2admin-admin-notAvailablePermissions')) 
      if(notAvailablePermissions.includes(to.path)){
        router.push('/noPermission')
      }
      // 如果to路由是目录的话就重定向到目录下有权限的菜单的第一项，但要忽略首页
      let asideList = JSON.parse(localStorage.getItem("d2admin-asideList")) || [] // 当前有权限的菜单列表
      if (asideList.some(item => item.path === to.fullPath) && to.fullPath != '/index') {
        // 找到对应项
        // for(let i = 0; i < asideList.length; i++) {
        //   if(to.fullPath === asideList[i].path) {
        //     // 如果有子菜单
        //     if(asideList[i].children && asideList[i].children.length > 0) {
        //       // 重定向到有权限的子菜单中第一项的path
        //       router.push(asideList[i].children[0].path)
        //     } else {
        //       // 如果没有子菜单，则显示没有权限
        //       router.push('/noPermission')
        //     }    
        //   }
        // }
        for (let i = 0; i < asideList.length; i++) {
          if (to.fullPath === asideList[i].path) {
            // 如果有子菜单
            if (asideList[i].children && asideList[i].children.length > 0) {
              // 重定向到有权限的子菜单中第一项的path
              if (from.fullPath != asideList[i].children[0].path) {
                // 如果还有二级菜单就跳到二级菜单中第一项的path
                if (asideList[i].children[0].children && asideList[i].children[0].children.length > 0) {
                  if (from.fullPath != asideList[i].children[0].children[0].path) {
                    router.push(asideList[i].children[0].children[0].path)
                  } else {
                    // 如果跳转路由和当前路由重复，则不跳转并结束加载效果
                    NProgress.done()
                  }
                } else {
                  router.push(asideList[i].children[0].path)
                }
              } else {
                // 如果跳转路由和当前路由重复，则不跳转并结束加载效果
                NProgress.done()
              }
            } else {
              // 如果没有子菜单，则显示没有权限
              router.push('/noPermission')
            }
          }
        }
      } else {
        // 如果不是目录路由就继续跳转
        next()
      }
      // next()
    } else {
      // 没有登录的时候跳转到登录界面
      // 携带上登录成功之后需要跳转的页面完整路径
      util.cookies.remove('token')
      util.cookies.remove('uuid')
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
      // https://github.com/d2-projects/d2-admin/issues/138
      NProgress.done()
    }
  } else {
    // 不需要身份校验 直接通过
    next()
  }
})

router.afterEach(to => {
  // 进度条
  NProgress.done()
  // 多页控制 打开新的页面
  store.dispatch('d2admin/page/open', to)
  // 更改标题
  util.title(to.meta.title)
})

export default router
